// material-ui
import Box from '@mui/material/Box';

import IconButton from 'components/@extended/IconButton';

import { ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';

// assets
import SunOutlined from '@ant-design/icons/SunOutlined';
import MoonOutlined from '@ant-design/icons/MoonOutlined';
import { Tooltip } from '@mui/material';


// ==============================|| HEADER CONTENT - CUSTOMIZATION ||============================== //

export default function Customization() {
  const { mode, onChangeMode } = useConfig();

  const handleToggle = () => {
    onChangeMode(mode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT);
  };


  return (
    <>
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
    <Tooltip title={mode === ThemeMode.LIGHT ? 'Switch to Dark Mode' : 'Switch to Light Mode'}>
        <IconButton
          color="secondary"
          variant="light"
          sx={(theme) => ({
            color: 'text.primary',
            bgcolor: mode === ThemeMode.LIGHT ? 'grey.100' : 'transparent',
            ...theme.applyStyles('dark', { bgcolor: mode === ThemeMode.LIGHT ? 'background.default' : 'transparent' })            
          })}
          onClick={handleToggle}
          aria-label="settings toggler"
        >
          {mode === ThemeMode.LIGHT ? <MoonOutlined /> : <SunOutlined />}
        </IconButton>
        </Tooltip>
      </Box>
    </>
  );
}
